module.exports = __webpack_public_path__ + "static/media/img-lang-zh-Hans.3033d96d.svg";